<template>
  <form class="form form-filter-loyalty-results-ph-clients-details"
        @submit.prevent="getResults"
        style="margin-bottom: 15px">
    <div class="form-group">
      <div class="select-wrapper">
        <span v-if="year === null" class="select-placeholder">Wybierz rok</span>
        <select v-model="year" @change="getResults">
          <option v-for="item in years" :value="item">Wyniki za rok {{ item }}</option>
        </select>
      </div>
    </div>
  </form>
</template>

<script>
  import {mapGetters, mapState} from "vuex";
  import {createHelpers} from "vuex-map-fields";

  const { mapFields } = createHelpers({
    getterType: `loyalty/getField`,
    mutationType: `loyalty/updateField`,
  });

  export default {
    name: 'FormLoyaltyFilterClientResults',
    data() {
      return {
        show: false
      }
    },
    computed: {
      ...mapGetters('profile', ['getProfile']),
      ...mapState({
        sfa: state => state.clients.single ? state.clients.single.sfa : null,
        years: state => state.global.years ? state.global.years.userLoyaltyProgramResults : [],
      }),
      ...mapFields({
        // sfa: 'filterResultsForm.sfa',
        year: 'filterResultsForm.year',
      })
    },
    mounted() {
      this.show = true
    },
    methods: {
      getResults(){
        let payload = { 'sfa': this.sfa, 'year': this.year }
        this.$store.dispatch('loyalty/LOYALTY_RESULTS_REQUEST', payload).then(resp => {
          this.$store.commit('clients/CLIENTS_SET_LOYALTY_RESULTS', resp.data)
        });
      },
    }
  }
</script>